export default __webpack_public_path__ + "static/media/387.bc51aea7.png";